import { useState } from 'react';

import { useSessionTimeout } from '../../hooks/useSessionTimeout';
import { SessionTimeoutModal } from './SessionTimeoutModal';

function SessionTimeoutWarning() {
  const { continueSession, countdownLabel, isWarningVisible, warningLeadMinutes } = useSessionTimeout();
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleContinueSession = async () => {
    setIsSubmitting(true);
    try {
      await continueSession();
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <SessionTimeoutModal
      countdownLabel={countdownLabel}
      isOpen={isWarningVisible}
      isSubmitting={isSubmitting}
      warningLeadMinutes={warningLeadMinutes}
      onContinueSession={handleContinueSession}
    />
  );
}

export default SessionTimeoutWarning;
